import React, { useState, useEffect } from 'react';

/**
 * SocialDiscoveryBanner - Rotating witty banners encouraging social sharing.
 * Displays on Search, Map, and Marketplace pages.
 * "Hurricane force winds of laughter" style humor included.
 */

const WITTY_BANNERS = [
  { text: "Share with Others and Learn from What other People Search For, Today!", accent: '#047857', icon: 'fa-share-alt' },
  { text: "Your search history is someone else's treasure map. Share the wealth!", accent: '#34d399', icon: 'fa-map-marked-alt' },
  { text: "WARNING: Sharing protocols may cause spontaneous outbreaks of knowledge.", accent: '#fbbf24', icon: 'fa-exclamation-triangle' },
  { text: "People are literally searching for what you already found. Be a hero.", accent: '#FEF08A', icon: 'fa-mask' },
  { text: "Studies show 9 out of 10 researchers wish they had YOUR bookmarks.", accent: '#22d3ee', icon: 'fa-chart-bar' },
  { text: "Don't hoard knowledge like a dragon hoards gold. Share your fire!", accent: '#ef4444', icon: 'fa-fire' },
  { text: "Your categories could save someone 47 hours of Googling. That's almost 2 days of sleep.", accent: '#FDE047', icon: 'fa-bed' },
  { text: "Brain cells that share together, stay together. It's science. Probably.", accent: '#10b981', icon: 'fa-brain' },
  { text: "Plot twist: The real treasure was the search results we shared along the way.", accent: '#f59e0b', icon: 'fa-gem' },
  { text: "Imagine if Einstein kept E=mc\u00B2 to himself. Don't be anti-Einstein.", accent: '#FCD34D', icon: 'fa-atom' },
  { text: "Your protocols are so good, even the internet wants a copy. Share now!", accent: '#FDE68A', icon: 'fa-copy' },
  { text: "CAUTION: Shared knowledge has been known to cause success in others.", accent: '#14b8a6', icon: 'fa-user-graduate' },
];

const SocialDiscoveryBanner = ({ variant = 'default' }) => {
  const [idx, setIdx] = useState(() => Math.floor(Math.random() * WITTY_BANNERS.length));
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(prev => (prev + 1) % WITTY_BANNERS.length);
        setVisible(true);
      }, 300);
    }, 12000);
    return () => clearInterval(t);
  }, []);

  const banner = WITTY_BANNERS[idx];
  const isCompact = variant === 'compact';

  return (
    <div
      data-testid="social-discovery-banner"
      style={{
        background: `linear-gradient(90deg, ${banner.accent}08, ${banner.accent}15, ${banner.accent}08)`,
        border: `1px solid ${banner.accent}20`,
        borderRadius: isCompact ? 8 : 10,
        padding: isCompact ? '5px 12px' : '8px 16px',
        marginBottom: isCompact ? 6 : 10,
        display: 'flex',
        alignItems: 'center',
        gap: isCompact ? 8 : 12,
        overflow: 'hidden',
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(-4px)',
        transition: 'opacity 0.3s ease, transform 0.3s ease'
      }}
    >
      <i className={`fas ${banner.icon}`} style={{
        color: banner.accent, fontSize: isCompact ? '0.7rem' : '0.9rem', flexShrink: 0, opacity: 0.8
      }} />
      <span style={{
        color: banner.accent,
        fontSize: isCompact ? '0.58rem' : '0.68rem',
        fontWeight: 600,
        flex: 1,
        lineHeight: 1.4,
        letterSpacing: '0.01em'
      }}>{banner.text}</span>
      <span style={{
        color: '#555',
        fontSize: '0.42rem',
        whiteSpace: 'nowrap',
        flexShrink: 0
      }}>InfoPilot Social</span>
    </div>
  );
};

export default SocialDiscoveryBanner;
